import { DefinitionType, ObjectDefinitions, type ItemDefinition } from "../../utils/objectDefinitions";
import { PerkIds } from "./perks";

export interface HealingItemDefinition extends ItemDefinition {
    readonly defType: DefinitionType.HealingItem

    readonly healType: HealType
    readonly restoreAmount: number
    readonly useTime: number
    readonly effect?: {
        readonly removePerk?: PerkIds
        readonly restoreAmounts?: Heal[]
    }
    readonly hideUnlessPresent?: boolean
}
interface Heal {
    readonly healType: HealType
    readonly restoreAmount: number
}
export enum HealType {
    Health,
    Adrenaline,
    Special
}

export const HealingItems = new ObjectDefinitions<HealingItemDefinition>([
    {
        idString: "gauze",
        name: "Field Dressing",
        defType: DefinitionType.HealingItem,
        healType: HealType.Health,
        restoreAmount: 20,
        useTime: 3
    },
    {
        idString: "medikit",
        name: "Medikit",
        defType: DefinitionType.HealingItem,
        healType: HealType.Health,
        restoreAmount: 100,
        useTime: 6
    },

    {
        idString: "cola",
        name: "Cola",
        defType: DefinitionType.HealingItem,
        healType: HealType.Adrenaline,
        restoreAmount: 10,
        useTime: 3
    },
    {
        idString: "tablets",
        name: "Tablets",
        defType: DefinitionType.HealingItem,
        healType: HealType.Adrenaline,
        restoreAmount: 50,
        useTime: 4,
        // retired from loot (Field Meat from hares took its place); only shown if someone still carries some
        hideUnlessPresent: true
    },
    {
        // hunted: dropped by hares. Shown with the other healing items at the bottom left even when none is carried (0.97,
        // a tester's, passed on by the owner: "By default the 3 consumables, bandages, med kit and cola show at the bottom
        // left corner even if you have 0 in your bag, but field meat doesn't show up in that left corner menu unless you
        // pick one up"): it took the Tablets' place in the loot
        idString: "meat",
        name: "Field Meat",
        defType: DefinitionType.HealingItem,
        healType: HealType.Special,
        restoreAmount: 0,
        useTime: 4,
        effect: {
            restoreAmounts: [
                { healType: HealType.Health, restoreAmount: 20 },
                { healType: HealType.Adrenaline, restoreAmount: 50 }
            ]
        }
    },
    {
        idString: "vaccine_syringe",
        name: "Vaccine Syringe",
        defType: DefinitionType.HealingItem,
        healType: HealType.Special,
        restoreAmount: 0,
        useTime: 2,
        effect: {
            removePerk: PerkIds.Infected,
            restoreAmounts: [
                {
                    healType: HealType.Adrenaline,
                    restoreAmount: 50
                }
            ]
        },
        hideUnlessPresent: true
    }
]);
